import React from 'react';
import { Table, Typography } from 'antd';
import { createHouseAddress } from '../../../../shared/packages/address';

const columns = [
  { title: 'Адрес', dataIndex: 'address', key: 'address' },
  {
    title: 'Помещения',
    dataIndex: 'room',
    key: 'room',
    render: (room) => {
      return <Typography.Text>{room}</Typography.Text>;
    },
  },
];

const RegistrationAddressDescription = ({ room }) => {
  const data = [
    {
      key: 'room-main',
      address: createHouseAddress(room),
      room: getAddressData(room),
    },
  ];

  if (room.relatedFlats?.length) {
    room.relatedFlats.forEach((relatedRoom, index) => {
      data.push({
        key: `related-${index}`,
        address: createHouseAddress(relatedRoom),
        room: getAddressData(relatedRoom),
      });
    });
  }

  return (
    <Table
      size="small"
      bordered={false}
      columns={columns}
      dataSource={data}
      pagination={false}
    />
  );
};

export default RegistrationAddressDescription;

function getAddressData(room) {
  return [room.typeName, room.flat].join(' ');
}
